'use strict';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'isomorphic-fetch';
import React from 'react';
import EventCenterMap from './EventCenterMap';
import EventCenterField from './EventCenterField';

const DEFAULT_CENTER = { lat: 46.9429461, lng: 7.3842267 };

export default class EventCenterMapContainer extends React.Component {
  state = {}

  componentDidMount() {
    const url = `/api/events/${this.props.eventId}`;
    fetch(url).then(this.handleResponse);
  }

  handleResponse = (res) => {
    if (res.ok) { res.json().then(this.handleData); }
  }

  handleData = (data) => {
    const center = data.center;
    if (center) {
      this.changeCenter(center);
    } else {
      this.changeCenter(DEFAULT_CENTER);
    }
  }

  changeCenter = (val) => {
    this.setState({ center: val });
  }

  render() {
    const center = this.state.center;
    if (center) {
      const value = `POINT(${center.lat} ${center.lng})`;
      return (
        <div>
          <EventCenterMap lat={center.lat} lng={center.lng} changeCenter={this.changeCenter} />
          <EventCenterField value={value} />
        </div>
      );
    } else {
      return (<div></div>);
    }
  }
}
